// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet producten-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfProductenMaatschappijenGetSelecteerbareProductmaatschappijenVoorProductDto } from '../model/collectionResultOfProductenMaatschappijenGetSelecteerbareProductmaatschappijenVoorProductDto';

import type { CollectionResultOfProductenProductsGetGetProductenForAdvisorByPakketGroupDto } from '../model/collectionResultOfProductenProductsGetGetProductenForAdvisorByPakketGroupDto';

import type { CollectionResultOfProductenProductsGetGetPublicProductsProductDto } from '../model/collectionResultOfProductenProductsGetGetPublicProductsProductDto';

import type { ProductenGetByPakketParams } from '../model/productenGetByPakketParams';

import type { ProductenGetByProductIdListParams } from '../model/productenGetByProductIdListParams';

import type { ProductenGetByProductIdsParams } from '../model/productenGetByProductIdsParams';

import type { ProductenGetSelecteerbareProductmaatschappijenVoorProductParams } from '../model/productenGetSelecteerbareProductmaatschappijenVoorProductParams';

import type { Result1OfProductenProductsGetGetPublicWagenparkVoertuigenLimietenDto } from '../model/result1OfProductenProductsGetGetPublicWagenparkVoertuigenLimietenDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.ProductenInzien</li></ul>
 * @summary Geeft een lijst van producten terug voor de ingelogde adviseur.
 */
export const productenGetByPakket = (
  params?: MaybeRef<ProductenGetByPakketParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfProductenProductsGetGetProductenForAdvisorByPakketGroupDto>(
    { url: `/api/public/v1/producten`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getProductenGetByPakketQueryKey = (params?: MaybeRef<ProductenGetByPakketParams>) => {
  return ['api', 'public', 'v1', 'producten', ...(params ? [params] : [])] as const;
};

export const getProductenGetByPakketQueryOptions = <
  TData = Awaited<ReturnType<typeof productenGetByPakket>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<ProductenGetByPakketParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productenGetByPakket>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getProductenGetByPakketQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof productenGetByPakket>>> = ({ signal }) =>
    productenGetByPakket(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productenGetByPakket>>,
    TError,
    TData
  >;
};

export type ProductenGetByPakketQueryResult = NonNullable<
  Awaited<ReturnType<typeof productenGetByPakket>>
>;
export type ProductenGetByPakketQueryError = ErrorType<void>;

/**
 * @summary Geeft een lijst van producten terug voor de ingelogde adviseur.
 */

export function useProductenGetByPakket<
  TData = Awaited<ReturnType<typeof productenGetByPakket>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<ProductenGetByPakketParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productenGetByPakket>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductenGetByPakketQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.ProductenInzien</li></ul>
 * @summary Geeft de lijst van gevraagde producten terug.
 */
export const productenGetByProductIds = (
  params?: MaybeRef<ProductenGetByProductIdsParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfProductenProductsGetGetPublicProductsProductDto>(
    { url: `/api/public/v1/producten/byProductIds`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getProductenGetByProductIdsQueryKey = (
  params?: MaybeRef<ProductenGetByProductIdsParams>,
) => {
  return ['api', 'public', 'v1', 'producten', 'byProductIds', ...(params ? [params] : [])] as const;
};

export const getProductenGetByProductIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof productenGetByProductIds>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<ProductenGetByProductIdsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productenGetByProductIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getProductenGetByProductIdsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof productenGetByProductIds>>> = ({
    signal,
  }) => productenGetByProductIds(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productenGetByProductIds>>,
    TError,
    TData
  >;
};

export type ProductenGetByProductIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof productenGetByProductIds>>
>;
export type ProductenGetByProductIdsQueryError = ErrorType<void>;

/**
 * @summary Geeft de lijst van gevraagde producten terug.
 */

export function useProductenGetByProductIds<
  TData = Awaited<ReturnType<typeof productenGetByProductIds>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<ProductenGetByProductIdsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productenGetByProductIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductenGetByProductIdsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.ProductenInzien</li></ul>
 * @summary Geeft de lijst van gevraagde producten terug
 */
export const productenGetByProductIdList = (
  params?: MaybeRef<ProductenGetByProductIdListParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfProductenProductsGetGetPublicProductsProductDto>(
    {
      url: `/api/public/v1/producten/byProductIdList`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getProductenGetByProductIdListQueryKey = (
  params?: MaybeRef<ProductenGetByProductIdListParams>,
) => {
  return [
    'api',
    'public',
    'v1',
    'producten',
    'byProductIdList',
    ...(params ? [params] : []),
  ] as const;
};

export const getProductenGetByProductIdListQueryOptions = <
  TData = Awaited<ReturnType<typeof productenGetByProductIdList>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<ProductenGetByProductIdListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productenGetByProductIdList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getProductenGetByProductIdListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof productenGetByProductIdList>>> = ({
    signal,
  }) => productenGetByProductIdList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productenGetByProductIdList>>,
    TError,
    TData
  >;
};

export type ProductenGetByProductIdListQueryResult = NonNullable<
  Awaited<ReturnType<typeof productenGetByProductIdList>>
>;
export type ProductenGetByProductIdListQueryError = ErrorType<void>;

/**
 * @summary Geeft de lijst van gevraagde producten terug
 */

export function useProductenGetByProductIdList<
  TData = Awaited<ReturnType<typeof productenGetByProductIdList>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<ProductenGetByProductIdListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof productenGetByProductIdList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductenGetByProductIdListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.ProductenInzien</li></ul>
 * @summary Geeft de wagenpark voertuiglimieten terug, inclusief de algemene limiet en alle maatschappijlimieten.
 */
export const productenGetWagenparkVoertuigenLimieten = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfProductenProductsGetGetPublicWagenparkVoertuigenLimietenDto>(
    { url: `/api/public/v1/producten/wagenpark-voertuigen-limieten`, method: 'GET', signal },
    options,
  );
};

export const getProductenGetWagenparkVoertuigenLimietenQueryKey = () => {
  return ['api', 'public', 'v1', 'producten', 'wagenpark-voertuigen-limieten'] as const;
};

export const getProductenGetWagenparkVoertuigenLimietenQueryOptions = <
  TData = Awaited<ReturnType<typeof productenGetWagenparkVoertuigenLimieten>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof productenGetWagenparkVoertuigenLimieten>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getProductenGetWagenparkVoertuigenLimietenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productenGetWagenparkVoertuigenLimieten>>
  > = ({ signal }) => productenGetWagenparkVoertuigenLimieten(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof productenGetWagenparkVoertuigenLimieten>>,
    TError,
    TData
  >;
};

export type ProductenGetWagenparkVoertuigenLimietenQueryResult = NonNullable<
  Awaited<ReturnType<typeof productenGetWagenparkVoertuigenLimieten>>
>;
export type ProductenGetWagenparkVoertuigenLimietenQueryError = ErrorType<void>;

/**
 * @summary Geeft de wagenpark voertuiglimieten terug, inclusief de algemene limiet en alle maatschappijlimieten.
 */

export function useProductenGetWagenparkVoertuigenLimieten<
  TData = Awaited<ReturnType<typeof productenGetWagenparkVoertuigenLimieten>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productenGetWagenparkVoertuigenLimieten>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductenGetWagenparkVoertuigenLimietenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.MaatschappijenInzien</li></ul>
 * @summary Haalt de mogelijke SureNet maatschappijen op voor een product.
 */
export const productenGetSelecteerbareProductmaatschappijenVoorProduct = (
  productId: MaybeRef<string | undefined | null>,
  params?: MaybeRef<ProductenGetSelecteerbareProductmaatschappijenVoorProductParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  productId = unref(productId);
  params = unref(params);

  return customInstance<CollectionResultOfProductenMaatschappijenGetSelecteerbareProductmaatschappijenVoorProductDto>(
    {
      url: `/api/public/v1/producten/${productId}/maatschappijen`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getProductenGetSelecteerbareProductmaatschappijenVoorProductQueryKey = (
  productId: MaybeRef<string | undefined | null>,
  params?: MaybeRef<ProductenGetSelecteerbareProductmaatschappijenVoorProductParams>,
) => {
  return [
    'api',
    'public',
    'v1',
    'producten',
    productId,
    'maatschappijen',
    ...(params ? [params] : []),
  ] as const;
};

export const getProductenGetSelecteerbareProductmaatschappijenVoorProductQueryOptions = <
  TData = Awaited<ReturnType<typeof productenGetSelecteerbareProductmaatschappijenVoorProduct>>,
  TError = ErrorType<void>,
>(
  productId: MaybeRef<string | undefined | null>,
  params?: MaybeRef<ProductenGetSelecteerbareProductmaatschappijenVoorProductParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productenGetSelecteerbareProductmaatschappijenVoorProduct>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getProductenGetSelecteerbareProductmaatschappijenVoorProductQueryKey(
    productId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productenGetSelecteerbareProductmaatschappijenVoorProduct>>
  > = ({ signal }) =>
    productenGetSelecteerbareProductmaatschappijenVoorProduct(
      productId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(productId) !== null && unref(productId) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof productenGetSelecteerbareProductmaatschappijenVoorProduct>>,
    TError,
    TData
  >;
};

export type ProductenGetSelecteerbareProductmaatschappijenVoorProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof productenGetSelecteerbareProductmaatschappijenVoorProduct>>
>;
export type ProductenGetSelecteerbareProductmaatschappijenVoorProductQueryError = ErrorType<void>;

/**
 * @summary Haalt de mogelijke SureNet maatschappijen op voor een product.
 */

export function useProductenGetSelecteerbareProductmaatschappijenVoorProduct<
  TData = Awaited<ReturnType<typeof productenGetSelecteerbareProductmaatschappijenVoorProduct>>,
  TError = ErrorType<void>,
>(
  productId: MaybeRef<string | undefined | null>,
  params?: MaybeRef<ProductenGetSelecteerbareProductmaatschappijenVoorProductParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productenGetSelecteerbareProductmaatschappijenVoorProduct>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductenGetSelecteerbareProductmaatschappijenVoorProductQueryOptions(
    productId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
